// extracted by mini-css-extract-plugin
export default {"icons":"FixedIcons_icons__X3VDr","icons__whats":"FixedIcons_icons__whats__JvvDD","icons__arrow":"FixedIcons_icons__arrow__speCm"};